var _title, _defs, _rect, _tspan, _tspan2, _tspan3, _tspan4, _g, _rect2, _circle, _circle2, _circle3, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmptyProviders = function SvgEmptyProviders(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Artboard@2x")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "86.6230987%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "86.5878523%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Import-services",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Empty-state",
    transform: "translate(-661.000000, -320.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(120.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(489.000000, 260.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(52.000000, 0.000000)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "url(#linearGradient-2)",
    fill: "url(#linearGradient-1)",
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 119,
    rx: 4
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uD83D\\uDC4D",
    fill: "#D8D8D8",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "luminosity"
    },
    fontFamily: "AppleColorEmoji, Apple Color Emoji",
    fontSize: 6,
    fontWeight: "normal",
    "line-spacing": 12
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 25
  }, "\uD83D\uDC4D"))), /*#__PURE__*/React.createElement("text", {
    id: "\\uD83D\\uDD25",
    fill: "#D8D8D8",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "luminosity"
    },
    fontFamily: "AppleColorEmoji, Apple Color Emoji",
    fontSize: 6,
    fontWeight: "normal",
    "line-spacing": 12
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 41
  }, "\uD83D\uDD25"))), /*#__PURE__*/React.createElement("text", {
    id: "\\uD83D\\uDE0D",
    fill: "#D8D8D8",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "luminosity"
    },
    fontFamily: "AppleColorEmoji, Apple Color Emoji",
    fontSize: 6,
    fontWeight: "normal",
    "line-spacing": 12
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 57
  }, "\uD83D\uDE0D"))), /*#__PURE__*/React.createElement("text", {
    id: "\\u2764\\uFE0F",
    fill: "#D8D8D8",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "luminosity"
    },
    fontFamily: "AppleColorEmoji, Apple Color Emoji",
    fontSize: 6,
    fontWeight: "normal",
    "line-spacing": 12
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 73
  }, "\u2764\uFE0F"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(24.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#E6E6E6",
    opacity: 0.600000024
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 52,
    height: 4,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    opacity: 0.5,
    transform: "translate(0.000000, 16.000000)",
    fill: "#E6E6E6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    opacity: 0.600000024,
    x: 0,
    y: 0,
    width: 30,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    opacity: 0.600000024,
    x: 34,
    y: 0,
    width: 48,
    height: 4,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(0.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    opacity: 0.600000024,
    x: 0,
    y: 0,
    width: 70,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "url(#linearGradient-3)",
    opacity: 0.5,
    x: 0,
    y: 16,
    width: 36,
    height: 4,
    rx: 1
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 0,
    y: 10,
    width: 120,
    height: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D8D8D8",
    cx: 5.5,
    cy: 5.5,
    r: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#D8D8D8",
    cx: 10.5,
    cy: 5.5,
    r: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#D8D8D8",
    cx: 15.5,
    cy: 5.5,
    r: 1.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(44.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#2E6DA4",
    fill: "#327AB7",
    cx: 16,
    cy: 16,
    r: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 10,
    y: 21,
    width: 12,
    height: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "16.942809 9 16.942205 15.5936466 18.6666667 13.9683936 20 15.2262952 16 19 12 15.2262952 13.3333333 13.9683936 15.0565869 15.5936466 15.057191 9"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyProviders, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-providers.276b11893b3fe30bc9a939031161ab04.svg";
export { ForwardRef as ReactComponent };